import styled from "styled-components";
import { useEffect, useState, useContext } from "react";
import AppContext from "AppContext";

const MOTIVATIONAL_EMOJIS = ['🚀', '👋', '👩🏽‍💻', '🎯', '⚡️'];
const CYCLE_INTERVAL = 250;
const INITIAL_DELAY = 300; // Delay before starting animation
const TOTAL_CYCLES = 3; // Number of complete cycles

export default function WelcomeBox() {
  const { userProfile } = useContext(AppContext);
  const [greeting, setGreeting] = useState("");
  const [currentTime, setCurrentTime] = useState(new Date());
  const [selectedEmoji, setSelectedEmoji] = useState('🚀');

  useEffect(() => {
    const getTimeBasedGreeting = () => {
      const hour = new Date().getHours();
      if (hour < 12) return "Good Morning";
      if (hour < 18) return "Good Afternoon";
      return "Good Evening";
    };

    setGreeting(getTimeBasedGreeting());
    
    // Add initial delay before starting animation
    const startAnimation = setTimeout(() => {
      let cycleCount = 0;
      let currentIndex = 0;
      
      const cycleEmojis = setInterval(() => {
        currentIndex = (currentIndex + 1) % MOTIVATIONAL_EMOJIS.length;
        setSelectedEmoji(MOTIVATIONAL_EMOJIS[currentIndex]);

        if (currentIndex === MOTIVATIONAL_EMOJIS.length - 1) {
          cycleCount++;
        }

        if (cycleCount >= TOTAL_CYCLES) {
          clearInterval(cycleEmojis);
          const randomIndex = Math.floor(Math.random() * MOTIVATIONAL_EMOJIS.length);
          setSelectedEmoji(MOTIVATIONAL_EMOJIS[randomIndex]);
        }
      }, CYCLE_INTERVAL);

      return () => clearInterval(cycleEmojis);
    }, INITIAL_DELAY);

    // Clear both timeouts on unmount
    return () => clearTimeout(startAnimation);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <Container className="WelcomeBox">
      <Box>
        <WelcomeText>
          {greeting}
          {userProfile?.userFname ? `, ${userProfile.userFname}!` : ''}
        </WelcomeText>
        <DateText>
          {currentTime.toLocaleDateString('en-US', {
            weekday: 'long',
            // year: 'numeric',
            month: 'long',
            day: 'numeric'
          })} @ {formatTime(currentTime)}
        </DateText>
        <WelcomeSubtext>
          Good luck with your day &nbsp; {selectedEmoji}
        </WelcomeSubtext>
      </Box>
    </Container>
  );
}

const Box = styled.div`
  padding: 20px;
  background: #222;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  text-align: left;
`;

const Container = styled.div`
  padding: 10px 10px 10px 10px;
  background: #111111;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  text-align: left;
`;

const WelcomeText = styled.p`
  margin: 0;
  font-weight: 600;
  color: white;
`;

const DateText = styled.p`
  margin: 0;
  font-size: 13px;
  color: #888;
  font-weight: 500;
  padding-bottom: 10px;
`;

const WelcomeSubtext = styled.p`
  margin: 0;
  font-size: 14px;
  color: #888;
  border-top: 1px solid #545454;
  padding-top: 5px;
`; 